/* eslint-disable prettier/prettier */
/* eslint-disable @next/next/no-img-element */
'use client';
import React, { useState } from 'react';
import { Card, Container, Collapse, Col } from 'react-bootstrap';
import './aboutMobile.css'; // Ensure your CSS file includes styles for the gradient and border
import { aboutDesc1, aboutDesc12, aboutDesc2 } from './text';
import Image from 'next/image';

export const AboutMobileComponent = () => {
  const [expanded, setExpanded] = useState(false);

  const handleReadMore = () => {
    if (typeof window !== 'undefined') {
      const aboutUsSection = document.getElementById('about-us');

      if (expanded) {
        // Scroll to the top of the section about us
        if (aboutUsSection) {
          aboutUsSection.scrollIntoView({
            behavior: 'smooth',
          });
        }
        // Set a delay before collapsing the card
        setTimeout(() => {
          setExpanded(false);
        }, 600);
      } else {
        setExpanded(true);
      }
    }
  };

  return (
    <Container data-aos="zoom-out">
      <Col md={12} className="text-center">
        <div className="heading">ABOUT US</div>
        <div className="heading-gallery"></div>
      </Col>
      <Card className="about-mobile-card">
        <Card.Body>
          <div className="logo-container" data-aos="zoom-out">
            <Image
              height={720}
              width={720}
              src="/assets/logo.png"
              alt="Logo"
              className="logo"
            />
          </div>
          <p
            className="aboutMobilecontent"
            data-aos="zoom-out"
            style={{
              textAlign: 'center',
            }}
          >
            {aboutDesc1} {expanded ? aboutDesc12 : ''}
          </p>
          <Collapse in={expanded}>
            <div>
              <p className="aboutMobilecontent">{aboutDesc2}</p>
              <p
                className="about-achievementMobile"
                style={{
                  fontSize: '20px !important',
                  textAlign: 'center !important',
                }}
              >
                <strong>NOTABLE HIGHLIGHTS</strong>
              </p>
              <p className="about-achievementMobile">
                <strong>•</strong> THE MOST FOLLOWED FOOTBALL FAN CLUB IN INDIA
              </p>
              <p className="about-achievementMobile">
                <strong>•</strong> 2x WINNERS OF BEST FAN CLUB IN INDIA AWARD BY
                INDIAN SPORTS HONOURS
              </p>
              <p className="about-achievementMobile">
                <strong>•</strong> PRESENCE ACROSS THE GLOBE WITH INTERNATIONAL
                WINGS INVOLVED IN MULTIPLE FOOTBALL AND SOCIAL ACTIVITIES
              </p>
            </div>
          </Collapse>
          <div onClick={handleReadMore} className="readMore">
            {expanded ? 'Read Less' : 'Read More...'}
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AboutMobileComponent;
